export var gradientConstants = {
    TYPES: {
        GRADIENT_LINEAR: 'GradientLinear',
        GRADIENT_ELLIPSE: 'GradientEllipse',
        GRADIENT_CIRCLE: 'GradientCircle',
        GRADIENT_CONIC: 'GradientConic',
    },
    CSS_FUNC: {
        RADIAL_GRADIENT: 'radial-gradient',
        CONIC_GRADIENT: 'conic-gradient',
        LINEAR_GRADIENT: 'linear-gradient',
    },
    REPEATING: 'repeating',
    DEG: 'deg',
    AT_CENTER: 'at center',
    CIRCLE: 'circle',
    ELLIPSE: 'ellipse',
    FROM: 'from',
    PERCENTAGE: 'percentage',
    RGBA: 'rgba',
};
//# sourceMappingURL=constants.js.map